<template>
  <div class="loginBox">
    <h1>Forgot password ?</h1>
      <div v-if="errors.length" class="errorCard">
        <p v-for="error in errors" :key="error">
          {{ error }}
        </p>
      </div>
      <form v-if="step==1" @submit.prevent="submit">
        <p style="color:black">Please enter your email to search for your account</p>
        <input type="email" v-model="email" placeholder="Email" :disabled="loading"/>
        <div style="display:flex; justify-content: space-between;">
          <a href="/login" class="btn">Cancel</a>
          <button class="btn primary" :disabled="loading">Submit</button>
        </div>
      </form>
      <div v-else>
        <p style="color: black;">
          Check your email adress and follow instruction to reset password
        </p>
      </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    email:null,
    loading: false,
    errors: [],
    step:1
  }),
  methods:{
    submit(){
      this.loading = true
      this.errors = []
      this.$store.dispatch("auth/forgot",{
        email:this.email,
      }).then(() => {
        this.step++
      }).catch(({data}) => {
        if(data.errors){
          console.log(data.errors)
          for (const entry of Object.entries(data.errors)) {
            this.errors.push(entry[1].join(","))
          }
        }else if(data.message){
          this.errors.push(data.message)
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="less">
.loginBox{
    text-align: left;
    max-width: 500px;
    width: 100%;
    background-color: #fff;
    padding: 50px;
    margin: 50px 0;
    h1{
      font-size: 24px;
      color: #2F2B2B;
      margin-bottom: 50px;
      font-weight: 800;
    }
    hr{
      border-color: transparent;
      margin-bottom: 30px;
      margin-top: 30px;
      display: block;
    }
    .errorCard{
      padding: 10px;
      margin-bottom: 25px;
      border-radius: 10px;
      background-color: #ef5350;
      color:#FFEBEE;
      p{
        line-height: 1.5em;
      }
    }
  }
</style>